const createSite = {
  form: {
    header: {
      title: ',Hallo,,',
    },

    fields: {
      sitePlaceHolder: 'specify your In & Out Locations,Bitte geben Sie Ihre Ein- und Ausgangsorte an, fill your site\'s name',
    },

    footer: {
      confirmButtonText: {
        create: 'Einreichen',
        update: 'Einreichen',
      },
    },

    information: {
      details: {
        header: 'Welches Szenario möchten Sie mit Moovex durchführen?',
        instructions: 'specify your In & Out Locations,Bitte geben Sie Ihre Ein- und Ausgangsorte an, check the field that describes your zone of business the most.',
      },
    },

    button: 'ICH MÖCHTE EIN SZENARIO BAUEN',
  },
};

export default createSite;
